import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/home/components/HomepageInteractive.tsx");
